import { createSlice } from "@reduxjs/toolkit";
import { NOTE_TYPE_VALUE } from "../../utils";

export const NOTE_TYPES = [NOTE_TYPE_VALUE.planner, NOTE_TYPE_VALUE.retailer];
export const NOTE_SAVE_TYPE = ["Store", "Common"];

export const initialState = {
  type: NOTE_TYPES[0],
  searchedType: NOTE_TYPES[0],
  saveType: NOTE_SAVE_TYPE[0],
};

export const notesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    setNoteType: (state) => {
      state.type = NOTE_TYPES.find((note) => note !== state.type);
    },
    setSearchedNoteType: (state) => {
      state.searchedType = state.type;
    },
    resetNotes: (state) => {
      state.type = initialState.type;
      state.saveType = initialState.saveType;
    },
    setNoteSaveType: (state) => {
      state.saveType = NOTE_SAVE_TYPE.find((note) => note !== state.saveType);
    },
    resetNoteSaveType: (state) => {
      state.saveType = initialState.saveType;
    },
  },
});

export const {
  setNoteType,
  setSearchedNoteType,
  resetNotes,
  setNoteSaveType,
  resetNoteSaveType,
} = notesSlice.actions;

export default notesSlice.reducer;
